import { FC } from 'react';
import { AccountProject } from './permissions-table.types';
import {
  Image,
  logos,
  Stack,
  TableCell,
  TextCaption,
} from '@pypestream/design-system';
import { ProductName } from '@pypestream/api-services';
import './permissions-table.scss';

export const getProductIcon = (productName: string) => {
  switch (productName) {
    case ProductName.AgentAssist:
      return logos.agentAssist;
    case ProductName.Analytics:
      return logos.analytics;
    case ProductName.Organization:
      return logos.org;
    case ProductName.ProStudio:
      return logos.proStudio;
    default:
      return 'Unknown Product';
  }
};

export const ProjectProductCell: FC<{
  projectProductSetting: AccountProject['project']['project_product_settings'][number];
}> = ({ projectProductSetting }) => (
  <TableCell nowrap>
    <Stack gutter="xsmall" nowrap>
      <Image
        width="16"
        height="16"
        src={getProductIcon(projectProductSetting.product.name)}
      />
      <TextCaption style={{ marginRight: 12 }}>
        {projectProductSetting.product?.displayName}
      </TextCaption>
    </Stack>
  </TableCell>
);
